import styled from "styled-components";


export const StyledInputBase = styled.div`
  .mantine-InputBase-input {
    /* border-color: var(--clr-gray-300); */

    &:focus,
    &:focus-within {
      border-color: var(--clr-primary-400);
    }
  }
`;
